import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete, TextField } from '@mui/material';
import MySearchIcon from '../components/MySearchIcon';

export const FormInputSearch = ({
  name = '',
  control,
  disabled = false,
  handleChange: propHandle,
  onChange = () => {},
  setValue: setForm = () => {},
  staticValue,
  options = [],
  rules,
  placeholder,
  type = 'text',
  size = 'small',
  sx,
  noOptionsText,
  loading = false,
  loadingText,
}) => {
  const [value, setValue] = useState(staticValue ?? null);

  function handleChange(_, selected) {
    setValue(selected);
    setForm(name, selected);
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        return (
          <Autocomplete
            id="search-box"
            disablePortal
            name={name}
            disabled={disabled}
            // disableCloseOnSelect
            noOptionsText={noOptionsText ? noOptionsText : '선택할 없습니다'}
            loading={loading}
            loadingText={loadingText ?? '불러오는 중...'}
            size={size}
            popupIcon={<MySearchIcon />}
            onInputChange={onChange}
            filterSelectedOptions
            getOptionLabel={option => option.name}
            renderOption={(props, option) => (
              <li {...props} key={option.id}>
                {option.name}
              </li>
            )}
            sx={{
              ...sx,
              '& .MuiAutocomplete-popupIndicator': { transform: 'none' },
            }}
            {...field}
            defaultValue={value}
            options={options}
            onChange={propHandle ?? handleChange}
            renderInput={params => (
              <TextField
                helperText={error ? error.message : null}
                error={!!error}
                type={type}
                placeholder={placeholder}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0F7F85',
                    },
                  },
                }}
                {...params}
              />
            )}
          />
        );
      }}
    />
  );
};
